// extracted by mini-css-extract-plugin
export default {"CountriesFeature":"wi_a bhy_b"};